module.exports = __webpack_public_path__ + "static/media/DOW.0d90e087.webp";